(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cafecito-lang-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    function initLangSwitchers() {
      document.querySelectorAll('.cf-lang').forEach(function (el) {
        if (el.dataset.langInit) return;
        el.dataset.langInit = 'true';

        var btn  = el.querySelector('.cf-lang__btn');
        var menu = el.querySelector('.cf-lang__menu');
        if (!btn || !menu) return;

        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          menu.hidden = isOpen;
        });

        document.addEventListener('click', function (e) {
          if (!el.contains(e.target)) {
            btn.setAttribute('aria-expanded', 'false');
            menu.hidden = true;
          }
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            btn.setAttribute('aria-expanded', 'false');
            menu.hidden = true;
          }
        });
      });
    }

    initLangSwitchers();
    document.addEventListener('shopify:section:load', initLangSwitchers);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cafecito-reveal"] && !Shopify.designMode) return;
  try {
    class CafecitoReveal extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('revealed');
        return;
      }
      const delay = this.dataset.delay || '0';
      this.style.setProperty('--reveal-delay', delay + 'ms');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('revealed');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      observer.observe(this);
    }
  }
  if (!customElements.get('cafecito-reveal')) {
    customElements.define('cafecito-reveal', CafecitoReveal);
  }
  } catch(e) { console.error(e); }
})();

})();
